import {DataTable} from '../ui/DataTable';
import {StatusBadge} from '../ui/StatusBadge';
import {Link} from '../ui/ScopedLink';
import {formatDateOnly} from '../dates';
import type {Version} from './ManagementFees';
const money=(value:string|null|undefined)=>value==null?'Not confirmed':new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(Number(value));

export function FeeVersionSummary({version:v}:{version:Version}){
 const terms=v.facts?.terms;
 return <div className="fee-version-readout">
  <div className="fee-version-state"><StatusBadge text={v.status}/><span>Effective {formatDateOnly(v.effectiveFrom,'Not recorded')}{terms?.effectiveTo?' to '+formatDateOnly(terms.effectiveTo):''}</span><span>{v.ready?'Evidence reviewed':'Review needed'}{!v.active?' · Outside current fee period':''}</span></div>
  {terms&&<DataTable caption={<span className="sr-only">Service-specific fee schedule</span>} scrollLabel="Agreed fee schedule" rows={terms.lines.map((line,index)=>({...line,index}))} getRowKey={row=>row.index}
   rowHeader={{id:'service',header:'Service',render:row=>row.label||'Description not recorded'}} columns={[
    {id:'basis',header:'Fee basis',render:row=>row.basis},
    {id:'count',header:'Agreed quantity',align:'right',render:row=>row.basis==='Per property annually'?row.count??'Not confirmed':'—'},
    {id:'rate',header:'Agreed rate',align:'right',render:row=>money(row.amount)},
    {id:'annual',header:'Annual base',align:'right',render:row=>money(v.calculation?.lines[row.index]?.annual)},
    {id:'vat',header:'VAT basis',render:()=>terms.vat.treatment+(terms.vat.rate===null?'':' · '+terms.vat.rate+'%')},
   ]}/>}
  {v.calculation&&<dl className="fee-summary-facts">
<div>
<dt>Annual net</dt>
<dd>{money(v.calculation.annual.net)}</dd>
</div>
<div>
<dt>Recorded VAT</dt>
<dd>{money(v.calculation.annual.vat)}</dd>
</div>
<div>
<dt>Annual gross</dt>
<dd>{money(v.calculation.annual.gross)}</dd>
</div>
<div>
<dt>Onboarding fee</dt>
<dd>{terms?.onboarding.state??'Unknown'} · {money(v.calculation.onboarding.gross)}</dd>
</div>
</dl>}
  {terms&&<dl className="fee-summary-facts">
<div>
<dt>Payment frequency</dt>
<dd>{terms.frequency}{terms.frequencyDetail?' · '+terms.frequencyDetail:''}</dd>
</div>
<div>
<dt>Payment terms</dt>
<dd>{terms.paymentTerms||'Not recorded'}</dd>
</div>
<div>
<dt>Onboarding invoice date</dt>
<dd>{formatDateOnly(terms.onboarding.invoiceDate,'Not recorded')}</dd>
</div>
<div>
<dt>Agreement evidence</dt>
<dd>{v.facts?.documentId?<Link to={'/documents/'+v.facts.documentId}>Open source agreement</Link>:'Not recorded or unavailable'}</dd>
</div>
</dl>}
  {v.missing.length>0&&<details><summary>{v.missing.length} fee checks need attention</summary><ul>{v.missing.map(item=><li key={item}>{item}</li>)}</ul></details>}
 </div>;
}
